<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.batchProperties}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="batch.batchName | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties modal-body">
  <div style="max-height:600px;overflow-y:auto;overflow-x:hidden;">
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.id}}</h4>
        <p class="truncate">{{batch.batchId}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.uuid}}</h4>
        <p>{{batch.batchUUID}}</p>
	</div>	  
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.name}}</h4>
        <p class="truncate">{{batch.batchName}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.status}}</h4>
        <p>{{batch.state}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.priority}}</h4>
        <p [ngClass]="{'high-priority' : 'High' == batch.priority}">{{batch.priority}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.dueDate}}</h4>
        <p>{{batch.dueDateStr || LOCALIZATION.none}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.createdDate}}</h4>
        <p>{{batch.createdDateStr}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">Number of Documents</h4>
        <p>{{batch.documents.length}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.owner}}</h4>
        <p>{{batch.owner || LOCALIZATION.none}}</p>
	</div>
	<!-- div class="list-group-item">
		<h4 class="list-group-item-heading">Category</h4>
        <p *ngIf="batch.category" class="truncate">{{batch.category.name || LOCALIZATION.none}}</p>
	</div -->
	
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.workflow}}</h4>
        <p>{{batch.workflowType}}</p>
	</div>	
	
	<!-- All custom/dynamic workflow parameters -->
	<div *ngFor='let p of batch.parameters'>
		<div *ngIf="'PARTICIPANT' == p.type">
			<div class="list-group-item">
				<h4 class="list-group-item-heading">{{p.displayName}}</h4>
		        <p>{{LOCALIZATION.task}}: {{p.values.workflow_task_name}} <br>{{LOCALIZATION.assignedTo}}:
		         {{p.values.awdx_user_id || p.values.awdx_group_id || p.values.jbpm_usertask_group || "Unassigned"}}</p>
			</div>		
		</div>
		<div *ngIf="p.type === 'DATE' && !(p.values | isEmpty)">
			<div class="list-group-item">
				<h4 class="list-group-item-heading">{{p.displayName}}</h4>
		        <p>{{p.values.dateValue}}</p>
			</div>		
		</div>
		<div *ngIf="p.type === 'STRING' && !(p.values | isEmpty)">
			<div class="list-group-item">
				<h4 class="list-group-item-heading">{{p.displayName}}</h4>
		        <p>{{p.values.stringValue}}</p>
			</div>		
		</div>
		<div *ngIf="p.type === 'BOOLEAN' && !(p.values | isEmpty)">
			<div class="list-group-item">
				<h4 class="list-group-item-heading">{{p.displayName}}</h4>
		        <p>{{p.values.booleanValue}}</p>
			</div>		
		</div>
		<div *ngIf="p.type === 'LIST' && !(p.values | isEmpty)">
			<div class="list-group-item">
				<h4 class="list-group-item-heading">{{p.displayName}}</h4>
		        <p>{{p.values.listValue}}</p>
			</div>		
		</div>		
	</div>	
	
	<div *ngIf="!(batch.comments | isEmpty) || !(batch.comments.comments | isEmpty) " class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.comments}}</h4>
        <p *ngFor='let c of batch.comments' class="dx-comment">
        	<span class="comment-date">{{c.commentDateStr}}</span>
        	<span class="comment-from" *ngIf="c.commentorId">({{c.commentorId}})</span>
        	<span class="comment-message">{{c.message}}</span>
        </p>
	</div>
  </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
